import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Component({
    selector: 'app-generate-image-section',
    templateUrl: './generate-image-section.component.html',
    styleUrl: './generate-image-section.component.scss',
})
export class GenerateImageSectionComponent {
    @HostListener('document:keydown.enter', ['$event'])
    onEnterClicked(event: KeyboardEvent): void {
        this.onGenerateImage();
    }

    @Input({ alias: 'initialPrompt', required: true }) prompt: string;
    @Input({ alias: 'isGeneratingImage', required: false }) isGeneratingImage: boolean;
    @Output('generateImage') generateImage = new EventEmitter<string>();

    onGenerateImage() {
        this.generateImage.emit(this.prompt);
    }
}
